import React from 'react';

function Header() {
	return (
		<header class="header text-center" id="colorful">
			<nav class="navbar navbar-expand-xl navbar-dark" >
	 
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
				   <span class="navbar-toggler-icon"></span>
				</button>
	 
				<div id="navigation" class="collapse navbar-collapse flex-column" >
					<div class="profile-section pt-3 pt-lg-0 my-3">
						<img class="img-fluid d-xl-flex" src={require('./polypods.png')} alt="image" />
						<div class="bio mb-3 my-md-5" style={{color:"#2d3436"}}>Nominate a podcast episode. It could be your own or any episode you think others should listen to!</div>
						<div class="my-5 my-md-5">
							<a class="btn btn-primary" href="https://polypods.typeform.com/to/Rlj6l7g1" target="_blank">Nominate</a>
						</div>
				<hr />
					</div>
	 
					<ul class="navbar-nav flex-column text-left">
						<li class="nav-item">
							<a class="nav-link" href="https://www.notion.so/About-Polypods-6819621e151f49b7af7b69d10aff9e99" target="_blank" style={{color:"#2d3436"}}><i class="fas fa-user fa-fw mr-2" style={{color:"#2d3436"}}></i>About Polypods</a>
						</li>
					</ul>
				</div>
			</nav>
		</header>
	  );
	
}

export default Header;